import React, { Component } from 'react';
import { TimelineLite, Power4 } from 'gsap/TweenMax';

import './header.css';

class Header extends Component {
    componentDidMount() {
        this.tl = new TimelineLite();

        const offset = 25;

        this.tl.delay(0.25);
        this.tl.fromTo(
            this.h1,
            1,
            { opacity: 0, y: `+=${offset}` },
            { opacity: 1, ease: Power4.easeOut, y: `-=${offset}` },
        );
        this.tl.fromTo(
            this.h2,
            1,
            { opacity: 0, y: `+=${offset}` },
            { opacity: 1, ease: Power4.easeOut, y: `-=${offset}` },
            '-=0.75',
        );
        this.tl.fromTo(
            this.p1,
            1,
            { opacity: 0, y: `+=${offset}` },
            { opacity: 1, ease: Power4.easeOut, y: `-=${offset}` },
            '-=0.75',
        );
        this.tl.fromTo(
            this.p2,
            1,
            { opacity: 0, y: `+=${offset}` },
            { opacity: 1, ease: Power4.easeOut, y: `-=${offset}` },
            '-=0.75',
        );
    }

    render() {
        return (
            <header className="header">
                <div className="container">
                    <h1 ref={(h1) => (this.h1 = h1)}>Footwear Protection Guide:</h1>
                    <h2 ref={(h2) => (this.h2 = h2)}>
                        A guide to selecting footwear that's suited to different jobs and workplace hazards.
                    </h2>
                    <p ref={(p1) => (this.p1 = p1)}>
                        Many jobs can be hard on your feet. But selecting the right footwear for
                        your workers isn’t just a matter of comfort — it’s imperative to prevent
                        worker injury and help ensure compliance.
                    </p>
                    <p ref={(p2) => (this.p2 = p2)}>
                        As an employer, it’s important to assess your jobsite’s risks and hazards, select the right
                        type of footwear for the environment, and reevaluate shoe selections as
                        needs change. Use this guide to help find the right safety and protective
                        footwear for your workforce.
                    </p>
                </div>
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/header.js